/**
 * Marketplace fallback fixtures — Bill prototype 2026-05-30 (CMDS array,
 * plus the channel catalog from /channels). Used by /marketplace when the
 * catalog/commands tables are empty (anon visitor on a preview DB that
 * doesn't have the schema seeded yet).
 *
 * Channel data is intentionally borrowed from lib/channels/fallback-catalog
 * so we don't have to keep two copies in sync — the same six channels and
 * 53 subchannels render here as on /channels/[key].
 */

import type { MarketplaceCommand } from '@/lib/marketplace/queries'
import { FALLBACK_CHANNELS } from '@/lib/channels/fallback-catalog'
import { DEMO_COMMANDS } from '@/lib/fixtures/demo-brand'

export const FALLBACK_MARKETPLACE_CHANNELS = Object.values(FALLBACK_CHANNELS)

function marketplaceCategory(category: string): MarketplaceCommand['category'] {
  return category === 'reporting' ? 'intelligence' : category as MarketplaceCommand['category']
}

export const FALLBACK_MARKETPLACE_COMMANDS: MarketplaceCommand[] = DEMO_COMMANDS.map((command, index) => ({
  id: command.id,
  name: command.name,
  short_description: command.description,
  long_description: null,
  category: marketplaceCategory(command.category),
  applies_to_channels: command.channels,
  can_schedule: true,
  display_order: index + 1,
  enabled: command.enabled,
}))
